// extracted by mini-css-extract-plugin
module.exports = {"card":"Productcard_card__2lOvr"};